import {Repository} from './Repository';

export default class FAQRepository extends Repository {
    constructor() {
        super();

        this.faqRequestPrefix = '/api/v1/faqs';
    }

    postFAQInfo = (url, param) => {
        return this.getRequestPromise('post', this.faqRequestPrefix + `/${url}`, param);
    };

    getFAQInfo = (url) => {
        return this.getRequestPromise('get', this.faqRequestPrefix + `/${url}`);
    };

    putFAQInfo = (url, param) => {
        return this.getRequestPromise('put', this.faqRequestPrefix + `/${url}`, param);
    };

    deleteFAQInfo = (id) => {
        return this.getRequestPromise('delete', this.faqRequestPrefix + `?id=${id}`);
    };
}
